<template>
  <v-card>
    <v-toolbar dark color="blue-grey white--text">
      <!-- <v-icon>contacts</v-icon> -->
      <v-toolbar-title class="white--text">
        <span class="title">การเข้าอบรม/สัมมนาของบุคลากรในสำนักงาน</span>
        <div class="body-2">หน่วยงานภายนอกสำนักงานวิชาศึกษาทั่วไปเป็นผู้จัด</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        append-icon="search"
        label="ค้นหา"
        single-line
        hide-details
        v-model="pagination.q"
        clearable
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <v-btn color="blue-grey" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่มรายการ</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        :total-items="pagination.totalItems"
        :pagination.sync="pagination"
        hide-actions
      >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
          <td>{{ props.item.letterNo }}</td>
          <td>{{ props.item.startDate | formatShortDate }}</td>
          <td>{{ props.item.endDate | formatShortDate }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.totalParticipants }}</td>
          <td>{{ props.item.location }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip left>
              <v-btn icon class="mx-0" slot="activator" @click="editItem(props.item)">
                <v-icon color="blue-grey">pageview</v-icon>
              </v-btn>
              <span>ดูข้อมูล</span>
            </v-tooltip>
            <v-btn icon class="mx-0" @click="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ pagination.q }}" found no results.
        </v-alert>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination :length="Math.ceil(pagination.totalItems / pagination.rowsPerPage)" v-model="pagination.page" :total-visible="7"></v-pagination>
      </div>
    </v-card-text>
    
    <component :is="formDialog" :item="editedItem" :title="title" :dialog="dialog" @dialog="close($event)"></component>

    <v-dialog v-model="preloading" persistent width="300">
      <v-card color="blue darken-3" dark>
        <v-card-text>
          กำลังโหลด...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import swal from 'sweetalert2'
import FormDialog from './formDialog.vue'

export default {
  components: {
    FormDialog
  },
  data () {
    return {
      dialog: false,
      formDialog: '',
      preloading: true,
      loading: false,
      search: '',
      title: {
        icon: null,
        text: null
      },
      headers: [
        { text: '#', sortable: false, align: 'center', width: '10'},
        { text: 'เลขที่หนังสือ', value: 'letterNo' },
        { text: 'วันเริ่มต้น', value: 'startDate' },
        { text: 'วันสิ้นสุด', value: 'endDate' },
        { text: 'ชื่อโครงการ/ประชุม/สัมมนา', value: 'name', sortable: false },
        { text: 'จำนวนผู้เข้าร่วม', value: 'totalParticipants' },
        { text: 'สถานที่', value: 'location', sortable: false },
        { sortable: false}
      ],
      pagination: {
        q: '',
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All
        sortBy: 'startDate',
        totalItems: 0
      },
      items: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {}
    }
  },
  computed: {

  },
  mounted () {
    this.reload ()
  },
  methods: {
    addItem () {
      this.title.icon = 'add'
      this.title.text = 'เพิ่มรายการการเข้าอบรม/สัมมนาของบุคลากรในสำนักงาน'
      this.formDialog = 'form-dialog'
      let item = {
        isGen: true,
        inside: true,
        letterNo: null,
        days: 0,
        activityPeriods: []
      }
      this.editedItem = Object.assign({}, item)
      setTimeout(()=>{this.dialog = true}, 300)
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.title.icon = 'description'
      this.title.text = 'เรียกดูรายการการเข้าอบรม/สัมมนาของบุคลากรในสำนักงาน'
      this.formDialog = 'form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      // confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          this.$store.dispatch('activityNonGen/delete', item)
            .then((response) => {
                console.log('reload:', response )
                this.reload()
              }).catch((error) => {
                swal('เกิดข้อผิดพลาด!', error.message, 'error')
              })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    close () {
      this.formDialog = null
      this.dialog = false
      this.reload ()
      this.editedItem = {}
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    reload () {
      this.loading = true
      this.$store.dispatch("activityNonGen/loadItemsAsPage", this.pagination)
        .then((response) => {
          // console.log('page in response ->', this.pagination.page)
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
          this.preloading = false
        }).catch((error)=>{
          // console.log('reload', error)
          this.loading = false
          this.preloading = false
          swal('Error!', error.message, 'error')
        })
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload(this)
    },
    'pagination.q' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.companyCode' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.companyName' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.category' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.searches.status' () {
      this.pagination.page = 1
      this.reload(this)
    },
    'pagination.page' () {
      this.reload(this)
    },
    'pagination.descending' () {
      this.reload(this)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/activity/nonGen/index.vue